import ProgressBar from 'progressbar.js';
import Splide from '@splidejs/splide';

const STUFF_IO = {
  getCookie: function(name) {
      var n = this.trackingID+'_'+name;
      var v = document.cookie.match('(^|;) ?' + n + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  },
  setCookie: function(name, value, days) {
      var d = new Date;
      var n = this.trackingID+'_'+name;
      d.setTime(d.getTime() + 24*60*60*1000*days);
      document.cookie = n + "=" + value + ";path=/;expires=" + d.toGMTString();
  },
  deleteCookie: function(name) {
      var n = this.trackingID+'_'+name;
      setCookie(n, '', -1); 
  },
  getTimeRemaining: function(endtime) {
      const total = Date.parse(endtime) - Date.parse(new Date());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      
      return {
        total,
        days,
        hours,
        minutes,
        seconds
      };
  }
}
  
jQuery(document).on('ready', function(){


  // Home page video section
  const videoLink = jQuery('.watch-video-section .vp-a');
  if ( videoLink.length > 0 ) {
      videoLink.clone().html('').appendTo('.watch-video-section .wp-block-media-text__media');
  }

  if ( jQuery('#rarityAccordion').length > 0 ) {
    var firstAccordion = jQuery('#rarityAccordion .accordion-item').first();
    firstAccordion.find('.accordion-collapse').addClass('show');
    firstAccordion.find('.accordion-button').removeClass('collapsed');
  }

  const mintCountdownTimers = jQuery('.stuffio-mint-countdown');

  if (mintCountdownTimers.length > 0) {

    mintCountdownTimers.each(function(i,e){
        
        const thisCountdown = jQuery(e);
        const countdownOuter = thisCountdown.parents('.chain-countdown-outer');
        const countdownInner = thisCountdown.parents('.countdown-inner');
        const unixMintTime = thisCountdown.data('mintdate');
        const mintURL = thisCountdown.data('minturl');

        if (unixMintTime == '') {
            return false;
        }

        const endtime = new Date( unixMintTime * 1000 );
        const monthName = endtime.toLocaleString('default', { month: 'short' });
        const dayNumber = endtime.getDate();
        const mintMonthDay = thisCountdown.find('.mint-monthday');
        const daysSpan = thisCountdown.find('.days');
        const hoursSpan = thisCountdown.find('.hours');
        const minutesSpan = thisCountdown.find('.minutes');
        const secondsSpan = thisCountdown.find('.seconds');
      
        if ( mintMonthDay.length > 0 ) {
            mintMonthDay.html('<span class="countdown-monthname">'+monthName+'</span>'+dayNumber);
        }

        function hideCountdown() {
            countdownInner.remove();
            countdownOuter.remove();
        }

        function updateClock() {
          const t = STUFF_IO.getTimeRemaining(endtime);
      
          daysSpan.html(t.days);
          hoursSpan.html( ('0' + t.hours).slice(-2) );
          minutesSpan.html( ('0' + t.minutes).slice(-2) );
          secondsSpan.html( ('0' + t.seconds).slice(-2) );
      
          if (t.total <= 0) {
            clearInterval(timeinterval);
            hideCountdown();
          }
        }

        
        if ( Date.parse(endtime) < Date.parse(new Date()) ) {
            hideCountdown();
            return;
        }
      
        const timeinterval = setInterval(updateClock, 1000);

    });

  }

  if ( jQuery('.audio-preview').length > 0 ) {

    jQuery('.audio-preview').each(function(i,e){
      var player_id = jQuery(e).attr('data-id');
      var audio = document.getElementById(`audio-${player_id}`);
      var playBtn = jQuery(e).find('.audio-controls .play');
      var pauseBtn = jQuery(e).find('.audio-controls .pause');
      var time = jQuery(`#controls-${player_id} .audio-track .time`);
      var audioPlay;

      if ( jQuery('body.single-book-dea').length > 0 ) {
        var progressLine = new ProgressBar.Line('#audio-timer-'+player_id, {
            color: '#00AFE5',
            trailColor: '#000',
            strokeWidth: 8
        });
        var playPauseBtn = jQuery(e).find('.audio-controls');
        playPauseBtn.on('click', function(f){
          f.preventDefault();
          if ( jQuery(this).hasClass('paused') ) {
              jQuery(this).toggleClass('paused').toggleClass('playing');
              jQuery('audio').trigger('pause');
              jQuery('button.play').show();
              jQuery('button.pause').hide();
              playBtn.hide();
              pauseBtn.show();
              audio.play();
              audioPlay = setInterval(function() {
                  // Get the value of what second the song is at
                  let audioTime = Math.round(audio.currentTime);
                  // We get songs all the time
                  let audioLength = Math.round(audio.duration)
                  // Assign a width to an element at time
                  jQuery('#audio-timer-'+player_id).attr('data-time', audioTime / audioLength);
                  progressLine.animate(parseFloat(audioTime / audioLength));
                  if (audioTime == audioLength ) {
                      playPauseBtn.toggleClass('paused').toggleClass('playing');
                      progressLine.set(0);
                      playBtn.show();
                      pauseBtn.hide();
                      clearInterval(audioPlay);
                  }
              })
          } else if ( jQuery(this).hasClass('playing') ) {
              jQuery(this).toggleClass('paused').toggleClass('playing');
              playBtn.show();
              pauseBtn.hide();
              audio.pause();
              progressLine.stop();
              clearInterval(audioPlay);
          }
        })
      } else {
        var circle = new ProgressBar.Circle('#audio-timer-'+player_id, {
            color: '#68e3eb',
            strokeWidth: 10
        });
        playBtn.on('click', function(f){
          f.preventDefault();
          jQuery('audio').trigger('pause');
          jQuery('button.play').show();
          jQuery('button.pause').hide();
          playBtn.hide();
          pauseBtn.show();
          audio.play();
          audioPlay = setInterval(function() {
              // Get the value of what second the song is at
              let audioTime = Math.round(audio.currentTime);
              // We get songs all the time
              let audioLength = Math.round(audio.duration)
              // Assign a width to an element at time
              jQuery('#audio-timer-'+player_id).attr('data-time', audioTime / audioLength);
              circle.animate(parseFloat(audioTime / audioLength));
              if (audioTime == audioLength ) {
                circle.set(0);
                playBtn.show();
                pauseBtn.hide();
                clearInterval(audioPlay);
              }
          })
        })
        pauseBtn.on('click', function(f){
          f.preventDefault();
          playBtn.show();
          pauseBtn.hide();
          audio.pause();
          circle.stop();
          clearInterval(audioPlay);
        })
      }
      
    })

  }

  // Grid Layout Buttons
    if ( jQuery('[data-gridlayout]').length > 0 ) {
        const layout = STUFF_IO.getCookie('gridLayout');
        if (layout != null) {
            jQuery('[data-gridlayout]').removeClass('active');
            jQuery('[data-gridLayout="'+layout+'"]').addClass('active');
            doGridLayout(layout);
        }
    }
    jQuery('[data-gridLayout]').on('click', function(e){
        e.preventDefault();
        const layout = jQuery(this).attr('data-gridLayout');
        doGridLayout(layout);
        jQuery('[data-gridlayout]').removeClass('active');
        jQuery('[data-gridLayout="'+layout+'"]').addClass('active');
        STUFF_IO.setCookie('gridLayout', layout, 365);
    });
    function doGridLayout(layout) {

      var gridClasses = ['dea-grid', 'row', 'loop-container', 'gx-3', 'gy-4'];

      switch(layout) {
        case 'small' :
          gridClasses = gridClasses.concat(['layout-small', 'row-cols-xl-6', 'row-cols-md-4', 'row-cols-2']);
        break;
        case 'large' :
          gridClasses = gridClasses.concat(['layout-large', 'row-cols-xl-3', 'row-cols-md-2', 'row-cols-1']);
        break;
        case 'list' :
          gridClasses = gridClasses.concat(['layout-list', 'row-cols-1']);
        break;
      }

      jQuery('.dea-grid').removeClass().addClass(gridClasses.join(' '));

    }

  // Sort/Filter Select Dropdowns
        // Show/hide sort/filter options when clicking sort/filter toggle on mobile.
        jQuery('.sortfilter-btn').on('click', function(e){
          e.preventDefault();
          jQuery(this).toggleClass('opened');
          jQuery('.stuffio-control:not(.active)').toggleClass('show');
      })
      if (jQuery('.stuffio-archive-controls select').length > 0) {

          jQuery('.stuffio-archive-controls select').on('change', function(e){
              const filterurl = jQuery(this).val();
              window.location = filterurl;
          })

      }
      jQuery(".custom-select").each(function () {
          var classes = jQuery(this).attr("class"),
              id = jQuery(this).attr("id"),
              name = jQuery(this).attr("name"),
              width = jQuery(this).attr('width'),
              selection = false;
          var template = '<div class="' + classes + '">';
          template += '<span class="custom-select-trigger">' + jQuery(this).attr("placeholder") + '</span>';
          template += '<div class="custom-options" style="min-width:' + width + 'px;">';
          jQuery(this).find("option").each(function () {
              if (jQuery(this).attr('class') != null && jQuery(this).attr('class').indexOf('selection') >= 0) {
                  selection = jQuery(this).attr("value");
              }
              template += '<span class="custom-option ' + jQuery(this).attr("class") + '" data-id="'+id+'" data-value="' + jQuery(this).attr("value") + '">' + jQuery(this).html() + '</span>';
          });
          template += '</div></div>';
      
          jQuery(this).wrap('<div class="custom-select-wrapper"></div>');
          jQuery(this).hide();
          jQuery(this).after(template);
      
          if (selection != false) {
              let element = jQuery('span[data-id="' + id + '"][data-value="' + selection + '"]');
              element.parents(".custom-select-wrapper").find("select").val(element.data("value"));
              element.parents(".custom-options").find(".custom-option").removeClass("selection");
              element.addClass("selection");
              element.parents(".custom-select").removeClass("opened");
              element.parents(".custom-select").find(".custom-select-trigger").text(element.text());
          }
      
      });
      jQuery(".custom-option:first-of-type").hover(function () {
          jQuery(this).parents(".custom-options").addClass("option-hover");
      }, function () {
          jQuery(this).parents(".custom-options").removeClass("option-hover");
      });
      jQuery(".custom-select-trigger").on("click", function () {
          jQuery('html').one('click', function () {
              jQuery(".custom-select").removeClass("opened");
          });
          jQuery('.custom-select-trigger').not(this).parents(".custom-select").removeClass("opened");
          jQuery(this).parents(".custom-select").toggleClass("opened");
          event.stopPropagation();
      });
      jQuery(".custom-option").on("click", function () {
          jQuery(this).parents(".custom-select-wrapper").find("select").val(jQuery(this).data("value"));
          jQuery(this).parents(".custom-options").find(".custom-option").removeClass("selection");
          jQuery(this).addClass("selection");
          jQuery(this).parents(".custom-select").removeClass("opened");
          jQuery(this).parents(".custom-select").find(".custom-select-trigger").text(jQuery(this).text());
          const filterurl = jQuery(this).attr('data-value');
          window.location = filterurl;
      });
      
    function updateBackground(splide_slider, slideIndex) {
        const activeSlide = splide_slider.Components.Slides.getAt(slideIndex).slide;
        const background = activeSlide.getAttribute('data-sliderbackground');
        jQuery('.dea-slider-block').css({
          background: `linear-gradient(rgba(0,0,0,1) 75px, rgba(0,0,0,0), rgba(0,0,0,1) calc(100% - 50px)), url(${background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat'
        }).addClass('bg-loaded');
    }

    if ( jQuery('.splide').length > 0 ) {
      jQuery('.splide').each(function(i,e) {
        const id = jQuery(e).attr('id');
        let splide_slider = new Splide( `#${id}`, {
          arrows: jQuery('.splide__slide').length > 1,
          rewind: true
        } );

        if ( jQuery(e).hasClass('dea-slider-splide') ) {
          
          // Set initial background when Splide is mounted
          splide_slider.on('mounted', function () {
            updateBackground(splide_slider, splide_slider.index);
          });

          splide_slider.on('move', function (move) {
            jQuery('.dea-slider-block').removeClass('bg-loaded');
          });

          // Update background when a new slide becomes active
          splide_slider.on('moved', function (newIndex) {
            setTimeout(function() {
              updateBackground(splide_slider, newIndex);
            }, 500);
          });

        }

        if ( jQuery(e).hasClass('dea-carousel-splide') ) {
          
          splide_slider.on('visible', function (slide) {

            jQuery(`#${id}`).toggleClass('hide-left-gradient', splide_slider.index === 0);

            jQuery(`#${id}`).toggleClass('hide-right-gradient', slide.index === (splide_slider.length - 1));
            
          });
          
        }

        splide_slider.mount();

      })
  }

  jQuery('#searchopen').on('click', function(e){
    e.preventDefault();
    jQuery('#searchfield').focus();
    jQuery('.header-search').addClass('open');
  });

  jQuery('#searchclose').on('click', function(e){
    e.preventDefault();
    jQuery('.header-search').removeClass('open');
  });

  jQuery('.press-search-toggle').on('click', function(e){
    e.preventDefault();
    jQuery('.press-searchform').css({display: 'flex'}).animate({opacity: '1'}, 400, 'swing', function(){
        jQuery('#press-searchfield').focus();
    });
  })
  jQuery('.press-search-close').on('click', function(e){
      e.preventDefault();
      jQuery('.press-searchform').animate({opacity: '0'}, 400, 'swing', function(){
          jQuery('.press-searchform').css({display: 'none'});
      });
  })

  jQuery('.dea-grid .dea').each((i,e)=>{

    let mint_datetime = jQuery(e).attr('data-mintdatetime');
    let mint_sold_out = jQuery(e).attr('data-soldout');

    if ( mint_datetime === "none" && mint_sold_out !== 'true' ) {
        jQuery(e).addClass('mint-status-coming-soon');
    } else if ( mint_datetime !== "none" && mint_sold_out !== "true" ) {
        
        let mint_started = Date.now() > (parseInt(mint_datetime) * 1000);
        jQuery(e).toggleClass('mint-status-minting', mint_started).toggleClass('mint-status-coming-soon', !mint_started);

    }

  });

})